<template>
    <div class="container project-over-view">
        <vue-headful
                title="Users - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3 class="mb-0">All Projects</h3>
                            </div>
                            <div class="col add-pro-button-outer">
                                <router-link :to="{name: 'website-project-add'}" class="btn btn-primary mb-0">Add Projects</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th class="text-center">Actions</th>
                                <th scope="col">S.No</th>
                                <th scope="col">Project Title</th>
                                <th scope="col">Project Date</th>
                                <th scope="col">Project End Date</th>
                                <th scope="col">Project Next Date</th>
                                <!--<th scope="col">Project Description</th>-->
                                <!--<th scope="col">Project Venue</th>-->
                                <th scope="col">Project Fees</th>
                                <th scope="col">Project City</th>
                                <th scope="col">Project Location</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(project, index) in allProjects" v-bind:key="index">
                                <td>
                                    <button @click="deleteProject(project.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete User"></button>
                                    <button @click="editProject(project.id)" type="button"
                                            class="btn btn-info fas fa-pen"
                                            data-toggle="tooltip" data-placement="top" title="Edit User"></button>
                                    <button @click="projectTimeline(project.id)" type="button" class="btn btn-info fab fa-creative-commons-sampling"
                                            data-toggle="tooltip" data-placement="top"
                                            title="Timeline Project"></button>
                                </td>
                                <td>{{project.id}}</td>
                                <td>{{project.project_title}}</td>
                                <td>{{project.project_date}}</td>
                                <td>{{project.project_date_registration_end}}</td>
                                <td>{{project.project_date_registration_next}}</td>
                                <!--<td>{{project.project_description}}</td>-->
                                <!--<td>{{project.project_venue}}</td>-->
                                <td>{{project.project_fee}}</td>
                                <td>{{project.project_city}}</td>
                                <td>{{project.project_location}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card shadow pt-3 d-flex justify-content-center">
                    <pagination pagination="pagination"></pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import _ from "lodash";

export default {
  data() {
    return {
      allProjects: {}
    };
  },
  methods: {
    goNew: function() {
      window.location.href = "/dashboard/website/project/new";
    },
    getAllProjects() {
      axios({
        url:
          "admin/projects?access_token=" + localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.allProjects = result.data.projects.data;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteProject(id) {
      axios({
        method: "delete",
        url: "admin/projects/delete/" + id,
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Project Deleted Successfully", "", "success");
            console.log(result);
            this.getAllProjects();
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    editProject: function(p_id) {
      window.location.href = "/dashboard/website/project/update/" + p_id;
    },
    projectTimeline: function(p_id) {
      window.location.href = "/dashboard/website/project/timeline/" + p_id;
    }
  },
  computed: {},
  mounted: function() {
    this.getAllProjects();
  }
};
</script>
<style lang="scss">
.project-over-view {
  .add-pro-button-outer {
    text-align: right;
  }
}
</style>
